<template>
  <div id="app">
    <template v-if="!this.isMaintenance">
      <router-view/>
      <div id="modals">
        <component v-for="(modal, i) in modals" :is="modal.component" v-bind:params="modal.params" v-bind:key="i"></component>
      </div>
    </template>
    <template v-if="this.isMaintenance">
      <div style="text-align: center;">
        <article>
          <div class="container pt24">
            <img src="/lib/images/maintenance_logo.png" alt="">
          </div>
          <p class="ttl-01 mb18 pt24 font-weight-bold fs16">メンテナンス中です</p>
          <div class="section">
            <p class="ttl-01 mb24 pt18 fs13">誠に申し訳ありませんが、ただいまメンテナンス中につき、ご利用いただくことが出来ません。詳細については下記リンクよりご確認下さい。</p>
            <button class="button fs16 mt8 mb16 pd16 radius200" v-on:click="openBrowser('https://info.carlifesquare.com')">詳細はこちら</button>
          </div>
        </article>
      </div>
    </template>
  </div>
</template>

<script>
import appVerApi from '@/store/Api/Common/appVer'
const store = require('./store/').default

export default {
  data: () => ({
    isMaintenance: null,
    isCardSpecPage: null
  }),
  methods: {
    openBrowser: function (url) {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.openBrowser(url)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.openBrowser.postMessage(url)
      }
    }
  },
  computed: {
    modals: () => {
      return store.getters.modals
    }
  },
  mounted () {
    const newRelicSnippetPath = process.env.VUE_APP_NEW_RELIC_SNIPPET_PATH
    // NewRelicの開発環境は存在しないため、除外
    if (newRelicSnippetPath) {
      this.$loadScript(newRelicSnippetPath)
    }

    appVerApi.get().then(res => {
      // 全機能がメンテナンスモードの場合はメンテナンス画面を表示する
      if (!Object.values(res.data.webviewMaintenance).includes(false)) {
        this.isMaintenance = true
      }

      // URLにcardspecが含まれていた場合はコスモザカードオーパス画面
      this.isCardSpecPage = location.href.indexOf('cardspec') > -1

      if (this.isCardSpecPage) {
        // コスモザカードオーパス申し込み画面は車検の画面ではないため、メンテ画面は表示しない。
        this.isMaintenance = false
      }

      if (this.isMaintenance) {
        // メンテモード中は戻るボタンを表示しない
        this.appDisplayBack(false)
      }
    }).catch(e => {
      console.log('appVerApi-error')
      console.log(e.message)
    })
  }
}
</script>
